<template>
  <BaseModal modal-content-class="first_daily">
    <div class="content">
      <h2>{{ $_translations.value.modal_bonus_phase_game_title }}</h2>

      <p>{{ $_translations.value.modal_bonus_phase_game_subtitle }}</p>

      <p class="bonus_game_txt">{{ $_translations.value.modal_bonus_phase_game_description }}</p>

      <BaseButton
        v-if="canPlay"
        button-class="fancy_btn"
        @click:button="$emit('start:bonusGame')"
      >
        {{ $_translations.value.modal_bonus_phase_game_button_proceed }}
      </BaseButton>

      <div v-else class="error_text">
        {{ $_translations.value.modal_bonus_phase_game_error_already_played }}
      </div>
    </div>
  </BaseModal>
</template>

<script setup>
import BaseModal from '@/components/modal/BaseModal.vue';
import BaseButton from '@/components/button/BaseButton.vue';

defineEmits(['start:bonusGame']);

defineProps({
  canPlay: {
    type: Boolean,
    default: true,
  },
});
</script>
